import wrapError from "@/components/helpers/wrapError"

export const apiFetchUserEmailAddresses = (success, error) => {
  $.ajax({
    type: "GET",
    url: "/api/emailAddress",
    success,
    error: wrapError(error, "apiFetchUserEmailAddresses"),
  })
}

export const removeUserEmail = (email, success, error) => {
  $.ajax({
    type: "DELETE",
    url: `/api/emailAddress/${email}`,
    success,
    error: wrapError(error, "removeUserEmail"),
  })
}

export const addUserEmail = (payload, success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/emailAddress",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(payload),
    success,
    error: wrapError(error, "addUserEmail"),
  })
}

export const apiFetchSubscriptions = (success, error) => {
  $.ajax({
    type: "GET",
    url: "/api/subscriptionSettingsManager",
    dataType: "JSON",
    success,
    error: wrapError(error, "apiFetchSubscriptions"),
  })
}

export const apiSaveSubscriptionSettings = (subscriptions, success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/subscriptionSettingsManager",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({ subscriptions }),
    success,
    error: wrapError(error, "apiSaveSubscriptionSettings"),
  })
}

export const updateOrgSettings = (settings, success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/organizationSettingsManager",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({ settings }),
    success,
    error: wrapError(error, "updateOrgSettings"),
  })
}

export const changePasswordLoggedIn = (
  currentPassword,
  newPassword,
  confirmNewPassword,
  success,
  error,
) => {
  $.ajax({
    method: "POST",
    url: "/api/password",
    dataType: "JSON",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({ currentPassword, newPassword, confirmNewPassword }),
    success,
    error: wrapError(error, "changePasswordLoggedIn"),
  })
}

export const apiUpdateStripeGiving = (params, success, error) => {
  $.ajax({
    method: "POST",
    url: "/api/portalSession",
    dataType: "JSON",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(params),
    success,
    error: wrapError(error, "apiUpdateStripeGiving"),
  })
}
